import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { PureComponent } from 'react'
import { addProtocol } from 'shared/util/url'
import { debounce } from 'core-decorators'
import css from './text.css'

/**
 * Text Area: Controls a text area
 *
 * @class TextArea
 */
export default class extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        value: PropTypes.string,
        autoSelect: PropTypes.bool,
        placeholder: PropTypes.string,
        onSubmit: PropTypes.func,
    }
    static defaultProps = {
        autoSelect: false,
        value: '',
    }
    state = {
        text: '',
    }
    componentDidMount() {
        const { value } = this.props
        this.setState({ text: value })
    }
    componentWillReceiveProps(nextProps) {
        const { value } = this.props

        if (nextProps.value !== value) {
            this.setState({
                text: nextProps.value,
            })
        }
    }
    onSubmit(e) {
        e.preventDefault()
        e.stopPropagation()
        const { text } = this.state
        const { autoSelect, onSubmit } = this.props
        if (this.input && autoSelect) {
            this.input.select()
        }
        onSubmit(text)
    }
    onBlur() {
        const { onBlur = () => {} } = this.props
        const { text } = this.state

        onBlur(text)
    }
    @debounce(500)
    onChangeDebounce() {
        const { onChange } = this.props
        const { text } = this.state
        onChange(text || '')
    }
    render() {
        const { className, type, placeholder, name, onChange } = this.props
        const { text } = this.state
        const isUrl = type === 'url'
        const textValue = text ? (isUrl ? addProtocol(text) : text) : ''
        return (
            <form className={className} onSubmit={e => this.onSubmit(e)}>
                {name && <span className={css.name}>{name}</span>}
                <div className={css.container}>
                    <textarea
                        ref={c => (this.input = c)}
                        className={css.textArea}
                        type={type}
                        value={textValue}
                        placeholder={placeholder}
                        spellCheck={false}
                        onChange={e => {
                            this.setState({ text: e.target.value || '' })
                            onChange && this.onChangeDebounce()
                        }}
                        onBlur={() => this.onBlur()}
                    />
                </div>
            </form>
        )
    }
}
